<template>
    <div class="process-relate">
        <div class="tools-bar">
            <div class="tools-btn-group">
                <el-button icon="el-icon-download" type="primary" @click="exportProcessRelateTreeList" :loading="exportLoading">导出</el-button>
            </div>
        </div>
        <tree-table :data="processRelateTreeList" :isShowCheckbox="false" :expandAll="true" :isShowProcessDetail="true" @checkProcessDetail="checkProcessDetail" :columns="processRelateTreeColumns" border />
        <el-dialog
            title="流程详情"
            :fullscreen="true"
            append-to-body
            :visible.sync="isShowProcessInstanceDetail"
            >
          <ProcessDetail
              v-if="isShowDetail"
              :key="loadTimer"
              :instances="instancesInfo"
              :isRead="true"
            /> 
          </el-dialog>
    </div>
</template>

<script>
import TreeTable from '@/components/TreeTable';
import { getProcessRelateTreeList, getProcessInstancesDetail } from '@/data-model';
import { API_PROCESS_RELATE_TREE_LIST_EXPORT_TO_EXCEL } from '@/common/constants';
export default {
    components: {
        TreeTable
    },
    data () {
        return {
            loadTimer: '',
            isShowDetail: false,
            isShowProcessInstanceDetail: false,
            instancesInfo: {},
            processRelateTreeList: [],
            processRelateTreeColumns: [
                {
                    text: '序号',
                    value: 'orderNum',
                    width: 200
                },
                {
                    text: '名称',
                    value: 'label'
                },
                {
                    text: '发起时间',
                    value: 'beginDate',
                    width: 180
                },
                {
                    text: '负责人',
                    value: 'assigneeUserName',
                    width: 100
                },
                {
                    text: '状态',
                    value: 'status',
                    width: 100,
                    isTag: true,
                    tagList: {
                        0: { view: 'info', label: '未开始' },
                        1: { view: 'info', label: '未分配' },
                        2: { view: 'primary', label: '待认领' },
                        3: { view: 'primary', label: '进行中' },
                        4: { view: 'warning', label: '快到期' },
                        5: { view: 'success', label: '已完成' },
                        6: { view: 'danger', label: '已延期' }
                    }
                },
                {
                    text: '节点类型',
                    value: 'nodeType',
                    width: 100,
                    isTag: true,
                    tagList: {
                        0: { view: 'primary', label: '主流程' },
                        1: { view: 'success', label: '子流程' },
                        2: { view: 'warning', label: '任务' }
                    }
                }
            ],
            selectNodeId: 0,
            popoverTreeLable: '',
            exportLoading: false
        };
    },
    props: {
        processInstanceId: {
            // 当前流程实例ID
            type: String
        }
    },
    created () {
        // this._initPage();
    },
    methods: {
        async _initPage () {
            this.handleViewProcessRelate();
        },
        async handleViewProcessRelate () {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let treeList = await getProcessRelateTreeList(this.processInstanceId);
            this.processRelateTreeList = treeList;
            loading.close();
        },
        async  checkProcessDetail (row) {
            // console.log(row);
            this.isShowDetail = false;
            this.loadTimer = new Date().getTime();
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.instancesInfo = await getProcessInstancesDetail(row.id);
            loading.close();
            this.isShowDetail = true;
            this.isShowProcessInstanceDetail = true;
        },
        async exportProcessRelateTreeList () {
            let url = `${API_PROCESS_RELATE_TREE_LIST_EXPORT_TO_EXCEL}`;
            url = url.replace(':processInstanceId', this.processInstanceId);
            this.exportLoading = true;
            this.download(url);
            setTimeout(() => { // 导出按钮转圈圈关闭
                this.exportLoading = false;
            }, 5000);
        },
        download (url) {
            var iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = url;
            document.body.appendChild(iframe);
        }
    }
};
</script>

<style lang="less">
// height: ~"calc(100% - 7vw)";
.process-relate {
    width: ~'calc(100% - 2vw)';
    height: ~'calc(100% - 20vh)';
    position: absolute;
    .tools-bar {
        float:right;
    }
    .el-header {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .el-main {
        padding: 0;
    }

    .el-aside {
        border-right: 1px solid #dcdfe6;
    }
    .el-table--border {
        border-bottom: 1px solid #ebeef5;
    }
    .has-gutter {
        .gutter {
            width: 17px !important;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ProcessRelateTree/ProcessRelateTree.vue